import { getConfig } from '@/config'

const STORAGE_KEY = 'kp_invite_share'

let share = loadStored()

function loadStored() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    return JSON.parse(raw)
  } catch (e) {
    return null
  }
}

function persist(data) {
  share = data
  try {
    if (data) sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data))
    else sessionStorage.removeItem(STORAGE_KEY)
  } catch (e) {
    /* ignore */
  }
}

function toSearchParams(search) {
  if (!search) return new URLSearchParams()
  if (typeof URLSearchParams !== 'undefined' && search instanceof URLSearchParams) return search
  if (typeof search === 'string') {
    const text = search.indexOf('?') >= 0 ? search.slice(search.indexOf('?') + 1) : search
    return new URLSearchParams(text)
  }
  const params = new URLSearchParams()
  Object.keys(search).forEach((key) => {
    const value = search[key]
    if (value == null || value === '') return
    params.set(key, Array.isArray(value) ? String(value[0] || '') : String(value))
  })
  return params
}

function hashSearch() {
  const hash = (typeof window !== 'undefined' && window.location.hash) || ''
  const index = hash.indexOf('?')
  return index >= 0 ? hash.slice(index) : ''
}

function firstParam(params, keys) {
  for (let i = 0; i < keys.length; i++) {
    const value = (params.get(keys[i]) || '').trim()
    if (value) return value
  }
  return ''
}

function addressParams() {
  if (typeof window === 'undefined') return new URLSearchParams()
  const fromSearch = new URLSearchParams(window.location.search)
  const fromHash = new URLSearchParams(hashSearch())
  fromHash.forEach((value, key) => {
    if (!fromSearch.get(key) && value) fromSearch.set(key, value)
  })
  return fromSearch
}

/**
 * URL：?code=分线推广码&shareId=会员分享码&agentId=代理ID
 * 不要把会员分享码塞进 code。
 */
export function applyInviteFromSearch(search) {
  const params = toSearchParams(search)
  const agentCode = firstParam(params, ['code', 'agentCode'])
  const shareId = firstParam(params, ['shareId'])
  const agentId = firstParam(params, ['agentId'])
  const channel = firstParam(params, ['channel'])
  if (!agentCode && !shareId && !agentId && !channel) return share

  const prev = share || {}
  const data = {
    shareId: shareId ? shareId.toUpperCase() : (prev.shareId || ''),
    code: agentCode ? agentCode.toUpperCase() : (prev.code || ''),
    agentCode: agentCode ? agentCode.toUpperCase() : (prev.agentCode || prev.code || ''),
    agentId: agentId || prev.agentId || '',
    channel: channel || prev.channel || '',
  }
  persist(data)
  return data
}

export function getInviteShare() {
  return share
}

/** 当前地址栏里的会员邀请码。没有 shareId 就不算邀请链接。 */
export function inviteShareIdInAddress() {
  return firstParam(addressParams(), ['shareId']).toUpperCase()
}

/** 当前地址栏里的分线推广码。 */
export function lineCodeInAddress() {
  return firstParam(addressParams(), ['code', 'agentCode']).toUpperCase()
}

export function agentIdInAddress() {
  return firstParam(addressParams(), ['agentId'])
}

export function channelInAddress() {
  return firstParam(addressParams(), ['channel'])
}

function siteDefault(key) {
  const value = String((getConfig()[key] || '')).trim()
  return value
}

/** 地址栏优先，再会话，最后用本站默认分线。 */
export function resolveLineCode() {
  const fromAddress = lineCodeInAddress()
  if (fromAddress) return fromAddress
  const saved = getInviteShare()
  if (saved && saved.agentCode) return String(saved.agentCode).trim().toUpperCase()
  if (saved && saved.code) return String(saved.code).trim().toUpperCase()
  return siteDefault('code').toUpperCase()
}

/** 下载定向：地址栏 agentId 优先，没有再用会话 / 本站默认。 */
export function resolveAgentId() {
  const fromAddress = agentIdInAddress()
  if (fromAddress) return fromAddress
  const saved = getInviteShare()
  if (saved && saved.agentId) return String(saved.agentId).trim()
  return siteDefault('agentId')
}

export function resolveChannel() {
  const fromAddress = channelInAddress()
  if (fromAddress) return fromAddress
  const saved = getInviteShare()
  if (saved && saved.channel) return String(saved.channel).trim()
  return siteDefault('channel')
}

export function inviteQuery() {
  return {
    code: resolveLineCode(),
    shareId: inviteShareIdInAddress(),
    agentId: resolveAgentId(),
    channel: resolveChannel(),
  }
}

/** 站内跳转时把地址栏上的 code / shareId / agentId / channel 带过去 */
export function withInviteQuery(query) {
  const invite = inviteQuery()
  const next = Object.assign({}, query || {})
  if (invite.code) next.code = invite.code
  if (invite.shareId) next.shareId = invite.shareId
  if (invite.agentId) next.agentId = invite.agentId
  if (invite.channel) next.channel = invite.channel
  return next
}

export function applyInviteFromLocation() {
  if (typeof window === 'undefined') return share
  applyInviteFromSearch(window.location.search)
  applyInviteFromSearch(hashSearch())
  return share
}
